if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('.product-media')
      this.mediaGalleryImages = this.querySelectorAll('[data-media-gallery-image]');
    }

    connectedCallback() {
      this.checkHeight();
      document.addEventListener('click', () => this.checkHeight());
    }

    checkHeight() {
      const buyBoxHeight = document.querySelector('[data-product-buybox]')?.offsetHeight;

      if (!buyBoxHeight) { return; }

      if (window.innerWidth >= 1025) {
        const imageGridHeight = this.grid.offsetHeight;

        if (buyBoxHeight > imageGridHeight) {
          this.grid.classList.add('lg:sticky', 'top-[125px]');
        } else {
          this.grid.classList.remove('lg:sticky', 'top-[125px]');
        }
      } else {
        this.grid.classList.remove('lg:sticky', 'top-[125px]')
      }
    }

    setActiveMedia(currentVariant) {
      let visibileImageCount = 0;

      this.mediaGalleryImages.forEach((image) => {
        const imageAlt = image.getAttribute('data-alt');

        if (imageAlt.indexOf('-') >= 0) {
          const imageAltSplit = imageAlt.split('-')[1].trim();

          if (imageAltSplit == currentVariant.option1 || imageAltSplit == currentVariant.option2 || imageAltSplit == currentVariant.option3) {
            image.classList.remove('hidden');
            visibileImageCount += 1;
          } else {
            image.classList.add('hidden');
          }
        } else {
          image.classList.remove('hidden');
          visibileImageCount += 1;
        }
      });

      if (visibileImageCount > 1) {
        this.grid.classList.remove('product-media--1-col');
      } else {
        this.grid.classList.add('product-media--1-col');
      }
    }
  });
}
